var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDawn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.739 3.244C7.816 3.764 3.199 8.784 3.199 16c0 6.684 3.96 11.484 10.045 12.568a9.69 9.69 0 0 1-.042-2.427c.318-2.83 1.552-4.544 2.855-6.356 1.073-1.49 2.193-3.046 2.888-5.343.829-2.736-.713-5.124-2.203-7.433-.816-1.263-1.616-2.503-2.004-3.763zm-.888 27.61C6.589 29.835 1 23.574 1 16 1 8.164 6.984 1.732 14.615 1.058a.118.118 0 0 1 .029-.006c.426-.035.854-.053 1.28-.052h.016c1.782 0 3.492.313 5.077.888a14.98 14.98 0 0 1 6.854 5.003c5.052 6.584 3.788 16-2.823 21.03A15.05 15.05 0 0 1 15.944 31h-.004c-.709 0-1.406-.05-2.088-.145z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDawn);
export default __webpack_public_path__ + "static/media/DAWN.527ea9d8dcb9cd6217cf39f4b8232878.svg";
export { ForwardRef as ReactComponent };